import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';
import { scrubBreadcrumb, scrubEvent } from './lib/sentryScrub';

// Sentry — captura de errores no controlados en el cliente (Fase 9.7).
// Si `VITE_SENTRY_DSN` no está set (dev local sin DSN), el SDK queda
// inactivo (`enabled: false`) y no envía nada. Plan free de Sentry,
// sin performance/tracing. Ver docs/operations/observability.md §Sentry.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION || undefined,
  // L3 — explícito aunque sea el default: no adjuntar PII (IP, cookies…) para
  // que no dependa de un default que puede cambiar entre versiones del SDK.
  sendDefaultPii: false,
  // L2 — Opción A: se conservan los breadcrumbs (contexto para depurar) pero se
  // limpia el UUID/PII de las URLs de Supabase (?id=eq.<uuid>). Doble red:
  // beforeBreadcrumb limpia cada breadcrumb de red; beforeSend barre el evento
  // entero. Ver src/lib/sentryScrub.ts.
  beforeBreadcrumb: (breadcrumb) => scrubBreadcrumb(breadcrumb),
  beforeSend: (event) => scrubEvent(event),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
